import { useState, useEffect} from 'react';
import AnimatedLetter from '../AnimatedLetters';
import './index.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCss3, faGitAlt, faHtml5, faJsSquare, faPython, faReact } from '@fortawesome/free-brands-svg-icons';
import Loader from 'react-loaders';
import { Link } from 'react-router-dom';

const About = () => {
    const [letterClass, setletterClass] = useState('text-animate')
    useEffect(() => {
        setTimeout(() => {
            setletterClass('text-animate-hover')
      }, 3000);
    }, [])

    return (
        <>
        <div className='container about-page'>
            <div className='text-zone'>
                <h1>
                    <AnimatedLetter 
                    letterClass={letterClass}
                        strArray={['A', 'b', 'o', 'u', 't', ' ', 'M', 'e']}
                        idx={15}
                    />
                </h1>
                <p>I'm a very ambitious front-end developer looking for a role in established IT company with the oppurtunity to work with the latest technologies on challenging and diverse projects.</p>
                <p>I'm quietly confident, naturally curious, and prepetually working on improving my skills.</p>
                <p>My name is Rudra Vashishtha. I am a technology enthusiast</p>
                <Link to="/contact" className='flat-button'>Projects</Link>
            </div>

            <div className='stage-cube-cont'>
                <div className='cubespinner'>
                    <div className='face1'>
                        <FontAwesomeIcon icon={faPython} color='#4B8BBE' />
                    </div>
                    <div className='face2'>
                        <FontAwesomeIcon icon={faReact} color='#5ED4F4' />
                    </div>
                    <div className='face3'>
                        <FontAwesomeIcon icon={faCss3} color='#28A4D9' />
                    </div>
                    <div className='face4'>
                        <FontAwesomeIcon icon={faHtml5} color='#F06529' />
                    </div>
                    <div className='face5'>
                        <FontAwesomeIcon icon={faJsSquare} color='#EFD81D' />
                    </div>
                    <div className='face6'>
                        <FontAwesomeIcon icon={faGitAlt} color='#EC4D28' />
                    </div>
                </div>
            </div>
        </div>
        <Loader type='pacman' />
        </>
    )
}

export default About;